
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/restaurants/[restaurant]",
      function () {
        return require("private-next-pages/restaurants/[restaurant]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/restaurants/[restaurant]"])
      });
    }
  